import React, { useState, useMemo } from 'react'

const TODAY = new Date('2026-04-14')

function daysUntil(dateStr) {
  return Math.ceil((new Date(dateStr) - TODAY) / (1000*60*60*24))
}
function rag(days) {
  if (days < 0)   return 'overdue'
  if (days <= 14) return 'red'
  if (days <= 30) return 'amber'
  return 'green'
}

const RAG = {
  overdue:{ bg:'#FFF0F0',border:'#E24B4A',dot:'#E24B4A',text:'#A32D2D',label:'OVERDUE' },
  red:    { bg:'#FFF4F4',border:'#E24B4A',dot:'#E24B4A',text:'#A32D2D',label:'URGENT'  },
  amber:  { bg:'#FFF8E6',border:'#C9973A',dot:'#C9973A',text:'#7A4A10',label:'DUE SOON'},
  green:  { bg:'#EAF3DE',border:'#3B6D11',dot:'#3B6D11',text:'#2A5A0A',label:'ON TRACK'},
}
const TYPE_CLR = {'Ltd':'#185FA5','Sole Trader':'#3B6D11','Landlord':'#C9973A','Partnership':'#7A4A10'}
const AUTH_CLR = {HMRC:'#185FA5',CH:'#C9973A'}

const CLIENTS = [
  {id:1, name:'Adeyemi Catering Ltd',       type:'Ltd',         contact:'Kunle Adeyemi',      filings:[{type:'VAT Return Q1',         authority:'HMRC',due:'2026-04-30'},{type:'RTI Payroll Apr',  authority:'HMRC',due:'2026-05-19'},{type:'CT600',            authority:'HMRC',due:'2026-07-31'},{type:'Annual Accounts',  authority:'CH',  due:'2026-10-31'}]},
  {id:2, name:'FW Catering Ltd',            type:'Ltd',         contact:'Folake Williams',    filings:[{type:'Conf. Statement',        authority:'CH',  due:'2026-04-23'},{type:'VAT Return Q1',    authority:'HMRC',due:'2026-04-30'},{type:'RTI Payroll Apr',  authority:'HMRC',due:'2026-05-19'},{type:'Annual Accounts',  authority:'CH',  due:'2026-11-30'}]},
  {id:3, name:'JO Tech Solutions Ltd',      type:'Ltd',         contact:'James Okonkwo',      filings:[{type:'RTI Payroll Apr',        authority:'HMRC',due:'2026-05-19'},{type:'VAT Return Q2',    authority:'HMRC',due:'2026-07-31'},{type:'CT600',            authority:'HMRC',due:'2026-09-30'},{type:'Conf. Statement',  authority:'CH',  due:'2026-12-15'}]},
  {id:4, name:'Bakare Properties Ltd',      type:'Ltd',         contact:'Bayo Bakare',        filings:[{type:'VAT Return Q1',         authority:'HMRC',due:'2026-05-07'},{type:'Annual Accounts',  authority:'CH',  due:'2026-08-31'},{type:'CT600',            authority:'HMRC',due:'2026-08-31'},{type:'Conf. Statement',  authority:'CH',  due:'2026-09-20'}]},
  {id:5, name:'Nwosu Construction Ltd',     type:'Ltd',         contact:'Chidi Nwosu',        filings:[{type:'RTI Payroll Apr',        authority:'HMRC',due:'2026-05-19'},{type:'VAT Return Q1',    authority:'HMRC',due:'2026-05-07'},{type:'CT600',            authority:'HMRC',due:'2026-10-31'},{type:'Annual Accounts',  authority:'CH',  due:'2026-10-31'}]},
  {id:6, name:'Okafor Logistics Ltd',       type:'Ltd',         contact:'Emeka Okafor',       filings:[{type:'Conf. Statement',        authority:'CH',  due:'2026-06-10'},{type:'VAT Return Q2',    authority:'HMRC',due:'2026-07-31'},{type:'Annual Accounts',  authority:'CH',  due:'2026-12-31'},{type:'CT600',            authority:'HMRC',due:'2026-12-31'}]},
  {id:7, name:'Eze Retail Solutions Ltd',   type:'Ltd',         contact:'Ngozi Eze',          filings:[{type:'VAT Return Q1',         authority:'HMRC',due:'2026-04-30'},{type:'RTI Payroll Apr',  authority:'HMRC',due:'2026-05-19'},{type:'Conf. Statement',  authority:'CH',  due:'2026-07-22'},{type:'Annual Accounts',  authority:'CH',  due:'2026-09-30'}]},
  {id:8, name:'Adesanya Digital Ltd',       type:'Ltd',         contact:'Tunde Adesanya',     filings:[{type:'CT600',                 authority:'HMRC',due:'2026-05-31'},{type:'VAT Return Q2',    authority:'HMRC',due:'2026-07-31'},{type:'Annual Accounts',  authority:'CH',  due:'2026-11-30'},{type:'Conf. Statement',  authority:'CH',  due:'2026-11-05'}]},
  {id:9, name:'Lawal Medical Services Ltd', type:'Ltd',         contact:'Bisi Lawal',         filings:[{type:'RTI Payroll Apr',        authority:'HMRC',due:'2026-05-19'},{type:'VAT Return Q1',    authority:'HMRC',due:'2026-04-30'},{type:'CT600',            authority:'HMRC',due:'2026-06-30'},{type:'Annual Accounts',  authority:'CH',  due:'2026-06-30'}]},
  {id:10,name:'Dada Consultants Ltd',       type:'Ltd',         contact:'Seun Dada',          filings:[{type:'Conf. Statement',        authority:'CH',  due:'2026-08-14'},{type:'VAT Return Q2',    authority:'HMRC',due:'2026-07-31'},{type:'CT600',            authority:'HMRC',due:'2027-01-31'},{type:'Annual Accounts',  authority:'CH',  due:'2027-01-31'}]},
  {id:11,name:'Chioma Nwosu Properties',    type:'Sole Trader', contact:'Chioma Nwosu',       filings:[{type:'Self Assessment 24/25', authority:'HMRC',due:'2027-01-31'},{type:'VAT Return Q1',    authority:'HMRC',due:'2026-04-30'},{type:'Class 2 NIC',      authority:'HMRC',due:'2027-01-31'}]},
  {id:12,name:'Sarah Mensah Consulting',    type:'Sole Trader', contact:'Sarah Mensah',       filings:[{type:'Self Assessment 24/25', authority:'HMRC',due:'2027-01-31'},{type:'Class 2 NIC',      authority:'HMRC',due:'2027-01-31'}]},
  {id:13,name:'Adunola Freelance Design',   type:'Sole Trader', contact:'Adunola Adeyemi',    filings:[{type:'Self Assessment 24/25', authority:'HMRC',due:'2027-01-31'},{type:'VAT Return Q1',    authority:'HMRC',due:'2026-05-07'}]},
  {id:14,name:'Bola Catering Services',     type:'Sole Trader', contact:'Bola Oduya',         filings:[{type:'Self Assessment 24/25', authority:'HMRC',due:'2027-01-31'},{type:'VAT Return Q2',    authority:'HMRC',due:'2026-07-31'}]},
  {id:15,name:'Kemi Osei Photography',      type:'Sole Trader', contact:'Kemi Osei',          filings:[{type:'Self Assessment 24/25', authority:'HMRC',due:'2027-01-31'}]},
  {id:16,name:'Ikeola Fatunwase',           type:'Landlord',    contact:'Ikeola Fatunwase',   filings:[{type:'Self Assessment 24/25', authority:'HMRC',due:'2027-01-31'},{type:'Rental Income SA', authority:'HMRC',due:'2027-01-31'}]},
  {id:17,name:'Duyilemi Properties',        type:'Landlord',    contact:'Oluyemisi Duyilemi', filings:[{type:'Self Assessment 24/25', authority:'HMRC',due:'2027-01-31'},{type:'Rental Income SA', authority:'HMRC',due:'2027-01-31'}]},
  {id:18,name:'Babatunde Rasheed',          type:'Landlord',    contact:'Babatunde Rasheed',  filings:[{type:'Self Assessment 24/25', authority:'HMRC',due:'2027-01-31'}]},
  {id:19,name:'Amaka Portfolio Ltd',        type:'Landlord',    contact:'Amaka Obi',          filings:[{type:'Self Assessment 24/25', authority:'HMRC',due:'2027-01-31'},{type:'VAT Return Q2',    authority:'HMRC',due:'2026-07-31'}]},
  {id:20,name:'Okonkwo & Fadare Partners',  type:'Partnership', contact:'James Okonkwo',      filings:[{type:'Partnership SA',        authority:'HMRC',due:'2027-01-31'},{type:'VAT Return Q1',    authority:'HMRC',due:'2026-04-30'}]},
  {id:21,name:'East London Care Partners',  type:'Partnership', contact:'Temi Ojengbede',     filings:[{type:'Partnership SA',        authority:'HMRC',due:'2027-01-31'},{type:'RTI Payroll Apr',  authority:'HMRC',due:'2026-05-19'},{type:'VAT Return Q1',    authority:'HMRC',due:'2026-04-30'}]},
]

export default function DeadlineTracker() {
  const [search,  setSearch]  = useState('')
  const [typeF,   setTypeF]   = useState('All')
  const [ragF,    setRagF]    = useState('All')
  const [authF,   setAuthF]   = useState('All')
  const [expanded,setExpanded]= useState(null)

  const allFilings = useMemo(() => {
    const r = []
    CLIENTS.forEach(c => c.filings.forEach(f => {
      const days = daysUntil(f.due)
      r.push({...f, client:c, days, status:rag(days)})
    }))
    return r.sort((a,b)=>a.days-b.days)
  },[])

  const overdue = allFilings.filter(f=>f.status==='overdue').length
  const urgent  = allFilings.filter(f=>f.status==='red').length
  const soon    = allFilings.filter(f=>f.status==='amber').length
  const ok      = allFilings.filter(f=>f.status==='green').length

  const filtered = useMemo(() => CLIENTS.filter(c => {
    const fs = c.filings.map(f=>({...f,days:daysUntil(f.due),status:rag(daysUntil(f.due))}))
    const worst = fs.some(f=>f.status==='overdue')?'overdue':fs.some(f=>f.status==='red')?'red':fs.some(f=>f.status==='amber')?'amber':'green'
    return (
      (!search || c.name.toLowerCase().includes(search.toLowerCase()) || c.contact.toLowerCase().includes(search.toLowerCase())) &&
      (typeF==='All' || c.type===typeF) &&
      (ragF==='All'  || worst===ragF) &&
      (authF==='All' || fs.some(f=>f.authority===authF))
    )
  }),[search,typeF,ragF,authF])

  return (
    <div style={{padding:20,maxWidth:1100}}>

      {/* Stats */}
      <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:12,marginBottom:20}}>
        {[['Overdue','overdue',overdue,'#E24B4A'],['Urgent < 14d','red',urgent,'#E24B4A'],['Due < 30d','amber',soon,'#C9973A'],['On track','green',ok,'#3B6D11']].map(([label,key,val,clr])=>(
          <div key={label} onClick={()=>setRagF(key)}
            style={{background:'white',border:'0.5px solid #e0e3e9',borderRadius:12,padding:'14px 16px',borderTop:`3px solid ${clr}`,cursor:'pointer'}}
            onMouseEnter={e=>e.currentTarget.style.boxShadow='0 4px 12px rgba(0,0,0,0.08)'}
            onMouseLeave={e=>e.currentTarget.style.boxShadow='none'}>
            <div style={{fontSize:10,color:'#999',textTransform:'uppercase',letterSpacing:'.05em',marginBottom:6}}>{label}</div>
            <div style={{fontSize:28,fontWeight:500,color:val>0&&key!=='green'?clr:'#1a1a2e'}}>{val}</div>
          </div>
        ))}
      </div>

      {/* Filters */}
      <div style={{display:'flex',gap:8,marginBottom:14,flexWrap:'wrap',alignItems:'center'}}>
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search client or contact..."
          style={{flex:1,minWidth:160,border:'0.5px solid #ccc',borderRadius:8,padding:'7px 12px',fontSize:12,fontFamily:'inherit',outline:'none'}}
          onFocus={e=>e.target.style.borderColor='#C9973A'} onBlur={e=>e.target.style.borderColor='#ccc'}/>
        <div style={{display:'flex',gap:3}}>
          {['All','Ltd','Sole Trader','Landlord','Partnership'].map(t=>(
            <button key={t} onClick={()=>setTypeF(t)}
              style={{padding:'6px 10px',borderRadius:7,border:'0.5px solid #ddd',fontSize:11,cursor:'pointer',fontFamily:'inherit',background:typeF===t?'#0B1929':'white',color:typeF===t?'#C9973A':'#666'}}>
              {t}
            </button>
          ))}
        </div>
        <div style={{display:'flex',gap:3}}>
          {[['All','All'],['overdue','⛔'],['red','🔴'],['amber','🟡'],['green','🟢']].map(([k,l])=>(
            <button key={k} onClick={()=>setRagF(k)}
              style={{padding:'6px 10px',borderRadius:7,border:'0.5px solid #ddd',fontSize:11,cursor:'pointer',fontFamily:'inherit',background:ragF===k?'#0B1929':'white',color:ragF===k?'#C9973A':'#666'}}>
              {l}
            </button>
          ))}
        </div>
        <div style={{display:'flex',gap:3}}>
          {['All','HMRC','CH'].map(a=>(
            <button key={a} onClick={()=>setAuthF(a)}
              style={{padding:'6px 10px',borderRadius:7,border:'0.5px solid #ddd',fontSize:11,cursor:'pointer',fontFamily:'inherit',background:authF===a?'#0B1929':'white',color:authF===a?'#C9973A':'#666'}}>
              {a==='CH'?'Co. House':a}
            </button>
          ))}
        </div>
        <button onClick={()=>{setSearch('');setTypeF('All');setRagF('All');setAuthF('All')}}
          style={{padding:'6px 10px',borderRadius:7,border:'0.5px solid #ddd',fontSize:11,cursor:'pointer',fontFamily:'inherit',color:'#888'}}>
          ✕ Clear
        </button>
      </div>

      <div style={{fontSize:11,color:'#aaa',marginBottom:10}}>Showing {filtered.length} of {CLIENTS.length} clients</div>

      {/* Table */}
      <div style={{background:'white',border:'0.5px solid #e0e3e9',borderRadius:12,overflow:'hidden',marginBottom:16}}>
        <div style={{display:'grid',gridTemplateColumns:'2fr 1fr 1.6fr 1fr 130px',padding:'9px 16px',background:'#f7f8fa',borderBottom:'0.5px solid #e0e3e9',fontSize:10,fontWeight:600,color:'#888',textTransform:'uppercase',letterSpacing:'.06em'}}>
          <div>Client</div><div>Type</div><div>Next filing</div><div>Authority</div><div>Status</div>
        </div>

        {filtered.length === 0 ? (
          <div style={{padding:40,textAlign:'center',color:'#aaa'}}>
            <div style={{fontSize:28,marginBottom:8,opacity:.3}}>🔍</div>
            <div>No clients match your filters</div>
          </div>
        ) : filtered.map((c,ci)=>{
          const fs = c.filings.map(f=>({...f,days:daysUntil(f.due),status:rag(daysUntil(f.due))})).sort((a,b)=>a.days-b.days)
          const next = fs[0]
          const worst = fs.some(f=>f.status==='overdue')?'overdue':fs.some(f=>f.status==='red')?'red':fs.some(f=>f.status==='amber')?'amber':'green'
          const R = RAG[worst]
          const isExp = expanded===c.id

          return (
            <div key={c.id}>
              <div onClick={()=>setExpanded(isExp?null:c.id)}
                style={{display:'grid',gridTemplateColumns:'2fr 1fr 1.6fr 1fr 130px',padding:'11px 16px',borderBottom:ci<filtered.length-1||isExp?'0.5px solid #e0e3e9':'none',cursor:'pointer',background:isExp?'#fafbff':'white',transition:'background .1s'}}
                onMouseEnter={e=>{if(!isExp)e.currentTarget.style.background='#fafafa'}}
                onMouseLeave={e=>{if(!isExp)e.currentTarget.style.background=isExp?'#fafbff':'white'}}>
                <div style={{display:'flex',alignItems:'center',gap:10}}>
                  <div style={{width:3,alignSelf:'stretch',minHeight:36,borderRadius:2,background:R.dot,flexShrink:0}}/>
                  <div>
                    <div style={{fontSize:12,fontWeight:500}}>{c.name}</div>
                    <div style={{fontSize:10,color:'#888',marginTop:1}}>{c.contact}</div>
                  </div>
                </div>
                <div style={{display:'flex',alignItems:'center'}}>
                  <span style={{fontSize:10,padding:'2px 8px',borderRadius:99,background:`${TYPE_CLR[c.type]}18`,color:TYPE_CLR[c.type],fontWeight:500}}>{c.type}</span>
                </div>
                <div style={{display:'flex',alignItems:'center'}}>
                  <div>
                    <div style={{fontSize:12,fontWeight:500}}>{next.type}</div>
                    <div style={{fontSize:10,color:'#aaa',marginTop:1}}>{new Date(next.due).toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric'})}</div>
                  </div>
                </div>
                <div style={{display:'flex',alignItems:'center'}}>
                  <span style={{fontSize:10,padding:'2px 8px',borderRadius:6,background:`${AUTH_CLR[next.authority]}15`,color:AUTH_CLR[next.authority],fontWeight:600}}>{next.authority==='CH'?'Co. House':'HMRC'}</span>
                </div>
                <div style={{display:'flex',alignItems:'center',gap:6}}>
                  <span style={{fontSize:10,padding:'3px 9px',borderRadius:99,background:R.bg,color:R.text,border:`0.5px solid ${R.border}`,fontWeight:600}}>
                    {next.days<0?`${Math.abs(next.days)}d late`:`${next.days}d`} · {R.label}
                  </span>
                  <span style={{fontSize:11,color:'#ccc',transform:isExp?'rotate(180deg)':'none',display:'inline-block'}}>▾</span>
                </div>
              </div>

              {isExp && (
                <div style={{background:'#f7f8fa',borderBottom:ci<filtered.length-1?'0.5px solid #e0e3e9':'none',padding:'8px 16px 12px 32px'}}>
                  <div style={{fontSize:10,fontWeight:600,color:'#aaa',textTransform:'uppercase',letterSpacing:'.08em',marginBottom:8}}>All filings for {c.name}</div>
                  <div style={{display:'flex',flexDirection:'column',gap:5}}>
                    {fs.map((f,fi)=>{
                      const FR=RAG[f.status]
                      return (
                        <div key={fi} style={{display:'flex',alignItems:'center',gap:10,padding:'8px 12px',background:'white',borderRadius:8,border:`0.5px solid ${FR.border}30`}}>
                          <div style={{width:8,height:8,borderRadius:'50%',background:FR.dot,flexShrink:0}}/>
                          <div style={{flex:1}}>
                            <span style={{fontSize:12,fontWeight:500}}>{f.type}</span>
                            <span style={{fontSize:11,color:'#888',marginLeft:8}}>{new Date(f.due).toLocaleDateString('en-GB',{day:'numeric',month:'long',year:'numeric'})}</span>
                          </div>
                          <span style={{fontSize:10,padding:'2px 7px',borderRadius:6,background:`${AUTH_CLR[f.authority]}15`,color:AUTH_CLR[f.authority],fontWeight:600}}>{f.authority}</span>
                          <span style={{fontSize:10,padding:'2px 8px',borderRadius:99,background:FR.bg,color:FR.text,fontWeight:500}}>
                            {f.days<0?`${Math.abs(f.days)}d overdue`:`${f.days}d left`}
                          </span>
                        </div>
                      )
                    })}
                  </div>
                </div>
              )}
            </div>
          )
        })}
      </div>

      {/* 30-day calendar strip */}
      <div>
        <div style={{fontSize:12,fontWeight:500,marginBottom:8}}>📅 Next 30 days</div>
        <div style={{display:'flex',flexDirection:'column',gap:5}}>
          {allFilings.filter(f=>f.days>=0&&f.days<=30).map((f,i)=>{
            const R=RAG[f.status]
            return (
              <div key={i} style={{display:'flex',alignItems:'center',gap:10,padding:'9px 14px',background:'white',border:`0.5px solid ${R.border}40`,borderRadius:9,borderLeft:`3px solid ${R.dot}`}}>
                <div style={{width:38,textAlign:'center',flexShrink:0}}>
                  <div style={{fontSize:15,fontWeight:700,color:R.dot,lineHeight:1}}>{f.days}</div>
                  <div style={{fontSize:9,color:'#aaa'}}>days</div>
                </div>
                <div style={{flex:1}}>
                  <div style={{fontSize:12,fontWeight:500}}>{f.client.name}</div>
                  <div style={{fontSize:11,color:'#888'}}>{f.type} · due {new Date(f.due).toLocaleDateString('en-GB',{day:'numeric',month:'short'})}</div>
                </div>
                <span style={{fontSize:10,padding:'2px 7px',borderRadius:6,background:`${AUTH_CLR[f.authority]}15`,color:AUTH_CLR[f.authority],fontWeight:600}}>{f.authority}</span>
                <span style={{fontSize:10,padding:'2px 8px',borderRadius:99,background:R.bg,color:R.text,fontWeight:600}}>{R.label}</span>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
